import React from 'react'
import style from './MainBlock.module.css'
const MainBlock = () => {
  return (
    <div className={style.main}>
      <div className={`${'customContainer'} ${style.main_wrap}`}>
        <h2 className={style.main_title}>Roofing</h2>
        <p className={style.main_desc}>
          Protect your property with XLeum’s high-performance roofing systems, engineered for long-lasting durability
        </p>
      </div>
    </div>
  )
}

export default MainBlock
